// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/common/pagination.proto

/* eslint-disable */

/** Pagination option for controlling result set size and position */
export interface ApiPaginationInput {
  /** Number of results to return per page */
  readonly perPage: number;
  /** Specifies either page-based or cursor-based pagination */
  readonly type?:
    | //
    /** Page number for page-based pagination (starts at 1) */
    { readonly $case: "page"; readonly value: number }
    | //
    /** Cursor token for cursor-based pagination */
    { readonly $case: "cursor"; readonly value: string }
    | null;
}

/**
 * Represents pagination metadata
 * It uses camel case so it may not be suitable for endpoints defined before proto standard
 */
export interface ApiPaginationMeta {
  /** Current page number */
  readonly currentPage: number;
  /** Next page number (null if no next page) */
  readonly nextPage?:
    | number
    | null
    | undefined;
  /** Previous page number (null if no previous page) */
  readonly prevPage?:
    | number
    | null
    | undefined;
  /** Total number of pages */
  readonly totalPages: number;
  /** Total number of orders */
  readonly totalCount: number;
  /** Number of results per page */
  readonly perPage: number;
  /** Cursor token for fetching the next set of results */
  readonly cursor?: string | null | undefined;
}

export const ApiPaginationInput: MessageFns<ApiPaginationInput> = {
  fromJSON(object: any): ApiPaginationInput {
    return {
      perPage: isSet(object.perPage) ? globalThis.Number(object.perPage) : 0,
      type: isSet(object.page)
        ? { $case: "page", value: globalThis.Number(object.page) }
        : isSet(object.cursor)
        ? { $case: "cursor", value: globalThis.String(object.cursor) }
        : null,
    };
  },

  toJSON(message: ApiPaginationInput): unknown {
    const obj: any = {};
    if (message.perPage !== undefined && message.perPage !== null) {
      obj.perPage = Math.round(message.perPage);
    }
    if (message.type?.$case === "page") {
      obj.page = Math.round(message.type.value);
    } else if (message.type?.$case === "cursor") {
      obj.cursor = message.type.value;
    }
    return obj;
  },
};

export const ApiPaginationMeta: MessageFns<ApiPaginationMeta> = {
  fromJSON(object: any): ApiPaginationMeta {
    return {
      currentPage: isSet(object.currentPage) ? globalThis.Number(object.currentPage) : 0,
      nextPage: isSet(object.nextPage) ? globalThis.Number(object.nextPage) : null,
      prevPage: isSet(object.prevPage) ? globalThis.Number(object.prevPage) : null,
      totalPages: isSet(object.totalPages) ? globalThis.Number(object.totalPages) : 0,
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
      perPage: isSet(object.perPage) ? globalThis.Number(object.perPage) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : null,
    };
  },

  toJSON(message: ApiPaginationMeta): unknown {
    const obj: any = {};
    if (message.currentPage !== undefined && message.currentPage !== null) {
      obj.currentPage = Math.round(message.currentPage);
    }
    if (message.nextPage !== undefined && message.nextPage !== null) {
      obj.nextPage = Math.round(message.nextPage);
    }
    if (message.prevPage !== undefined && message.prevPage !== null) {
      obj.prevPage = Math.round(message.prevPage);
    }
    if (message.totalPages !== undefined && message.totalPages !== null) {
      obj.totalPages = Math.round(message.totalPages);
    }
    if (message.totalCount !== undefined && message.totalCount !== null) {
      obj.totalCount = Math.round(message.totalCount);
    }
    if (message.perPage !== undefined && message.perPage !== null) {
      obj.perPage = Math.round(message.perPage);
    }
    if (message.cursor !== undefined && message.cursor !== null) {
      obj.cursor = message.cursor;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
